import { useState } from 'react';
import { Settings2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { UserConsole } from './UserConsole';
import type { UserRow } from '../types';

interface UserRowActionsProps {
  user: UserRow;
  /**
   * Edit URL prefix — main user list uses "/update-user", sub-user list
   * uses "/update-sub-user", sub-super-admin list uses "/sub-super-admin/update-user".
   */
  editPathPrefix: string;
  /** Hide the "Switch user" action (e.g. for non-impersonating contexts). */
  hideSwitchUser?: boolean;
  /** Hide TTS credit forms (when the target doesn't have a TTS module). */
  hideTtsCredits?: boolean;
}

/**
 * Single entry point per row — opens the User Console drawer where every
 * per-user action lives, organized into tabs. Replaces the legacy flat
 * 12-item kebab dropdown.
 */
export function UserRowActions({
  user,
  editPathPrefix,
  hideSwitchUser = false,
  hideTtsCredits = false,
}: UserRowActionsProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        aria-label={`Open settings for ${user.username}`}
        title="Settings"
        onClick={() => setOpen(true)}
      >
        <Settings2 className="h-4 w-4" />
      </Button>

      <UserConsole
        open={open}
        onOpenChange={setOpen}
        user={user}
        editPathPrefix={editPathPrefix}
        hideSwitchUser={hideSwitchUser}
        hideTtsCredits={hideTtsCredits}
      />
    </>
  );
}
